import { Actions } from '../actions/types';
import { SearchStyle } from '../Config';
import { ActionTypes as SearchActionTypes } from '../actions/search';
import { ActionTypes as PageActionTypes } from '../actions/page';
import { ISearchResult } from '../types';

export type ISearchReducerState = Readonly<
  | {
      inputValue: string;
      searchedTerm: null;
      isFetching: boolean;
      results: null;
      totalCount: null;
      currentPage: null;
      totalPages: null;
      isOpen: boolean;
    }
  | {
      inputValue: string;
      searchedTerm: string;
      isFetching: boolean;
      results: ReadonlyArray<ISearchResult>;
      totalCount: number;
      currentPage: number;
      totalPages: number;
      isOpen: boolean;
    }
>;

export const initialState: ISearchReducerState = {
  inputValue: '',
  searchedTerm: null,
  isFetching: false,
  results: null,
  totalCount: null,
  currentPage: null,
  totalPages: null,
  isOpen: false,
};

const reducer = (
  state: ISearchReducerState = initialState,
  action: Actions
): ISearchReducerState => {
  switch (action.type) {
    case PageActionTypes.PAGE_NAV_START: {
      if (action.payload.pageType !== 'search') return state;
      return {
        ...state,
        inputValue: action.payload.searchTerm,
        isFetching: true,
      };
    }

    case PageActionTypes.PAGE_NAV_COMPLETE: {
      if (action.payload.pageType !== 'search') return { ...initialState };

      const results = action.payload.data.searchArticles;
      return {
        inputValue: action.payload.searchTerm,
        isFetching: false,
        searchedTerm: action.payload.searchTerm,
        results: results.results,
        totalCount: results.pageInfo.totalCount,
        currentPage: results.pageInfo.currentPage,
        totalPages: results.pageInfo.totalPages,
        isOpen: false,
      };
    }

    case SearchActionTypes.SEARCH_INPUT_CHANGED: {
      if (action.payload.searchStyle === SearchStyle.resultsPage) {
        return {
          ...state,
          inputValue: action.payload.searchTerm,
          isOpen: false,
        };
      }

      // Dropdown clears the results on keychange.
      return {
        ...initialState,
        inputValue: action.payload.searchTerm,
        isOpen: !!action.payload.searchTerm.length,
      };
    }

    case SearchActionTypes.SEARCH_INPUT_FOCUSSED: {
      return {
        ...state,
        isOpen: !!state.inputValue.length,
      };
    }

    case SearchActionTypes.SEARCH_INPUT_BLURRED: {
      return {
        ...state,
        isOpen: false,
      };
    }

    case SearchActionTypes.SEARCH_RESET: {
      return { ...initialState };
    }

    case SearchActionTypes.SEARCH_FETCH_STARTED:
      return { ...state, isFetching: true };

    case SearchActionTypes.SEARCH_FAIL:
    case SearchActionTypes.SEARCH_CANCEL:
      return { ...state, isFetching: false };

    case SearchActionTypes.SEARCH_SUCCESS: {
      const {
        totalCount,
        totalPages,
        currentPage,
      } = action.payload.searchArticles.pageInfo;

      if (
        state.searchedTerm === action.payload.searchedTerm &&
        state.results &&
        state.currentPage !== currentPage
      ) {
        return {
          ...state,
          isFetching: false,
          results: state.results.concat(action.payload.searchArticles.results),
          totalCount,
          currentPage,
          totalPages,
        };
      }

      return {
        ...state,
        isFetching: false,
        results: action.payload.searchArticles.results,
        searchedTerm: action.payload.searchedTerm,
        totalCount,
        currentPage,
        totalPages,
        isOpen: true,
      };
    }
  }
  return state;
};

export default reducer;
